import { render, staticRenderFns } from "./bell-btn.vue?vue&type=template&id=39d7b2ce&"
import script from "./bell-btn.vue?vue&type=script&lang=js&"
export * from "./bell-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports